
export const useShouldShowLockedContent = ({ option, isNutrition,  isClient }: {
  option: boolean,
  isNutrition: boolean,
  isClient: boolean,
}): boolean => {
  // BEFORE:
  // options.isLockedContentDisplayed && !isClient
  const userPermission = !isClient;
  const contentPermission = !isNutrition;
  const res = option && userPermission && contentPermission;
  return res;
};
